export default __webpack_public_path__ + "static/media/arch.3a979d2f.svg";